import { updatePropertyTypeFilterFields } from './property-type-filter-fields.js';

export function init() {
	/* 投資・事業用: 種別連動なし。data-bukken-type-filter が残っても住宅用マップで壊れないよう init しない */
	if (document.querySelector('.bukkenList--investmentProperty')) {
		return;
	}

	const typeFilter = document.querySelector('[data-bukken-type-filter]');
	if (!typeFilter) return;

	const typeInputs = Array.from(typeFilter.querySelectorAll('input[name="type"]'));
	if (!typeInputs.length) return;

	const fieldElements = Array.from(document.querySelectorAll('[data-bukken-filter-field]'));
	const defaultInput = typeInputs.find((input) => input.value === 'new') ?? typeInputs[0];

	function applySelection(nextInput) {
		typeInputs.forEach((input) => {
			input.checked = input === nextInput;
			const label = input.closest('.bukkenList__filterCheck');
			if (label) {
				label.classList.toggle('is-checked', input === nextInput);
			}
		});
		updatePropertyTypeFilterFields(nextInput.value, fieldElements);
	}

	typeInputs.forEach((input) => {
		input.addEventListener('click', (event) => {
			event.preventDefault();
			applySelection(input);
		});

		input.addEventListener('change', () => {
			applySelection(input);
		});
	});

	const initiallyCheckedInput = typeInputs.find((input) => input.checked) ?? defaultInput;
	applySelection(initiallyCheckedInput);
}
